import {FeatureCollection} from '@turf/turf';
import {getCameraBoundingBox, toIGNBBoxString} from '../../cesiumTools';
import {LayerDatasource, LayerLoadType, MapperViewer} from '../../types';

export class RoadLayer implements LayerDatasource {

  id = 'road';
  name = 'Routes';
  active = false;
  dataSource = new Cesium.GeoJsonDataSource(this.name);
  loadType = LayerLoadType.Manual;
  viewer: MapperViewer;
  showLabel = false;
  isLoading = false;

  url = 'https://data.geopf.fr/wfs/?SERVICE=WFS&REQUEST=GetFeature&VERSION=2.0.0&TYPENAMES=BDTOPO_V3:route_numerotee_ou_nommee&SRSNAME=urn:ogc:def:crs:EPSG::4326&OUTPUTFORMAT=application/json&BBOX=';

  previouslyLoadedBbox = null;

  constructor() {}

  onBeforePrint(): void {

  }
  onAfterPrint(): void {

  }

  initialize(viewer: MapperViewer): void {
    this.viewer = viewer;
    viewer.dataSources.add(this.dataSource);
  }

  remove(): void {
    this.viewer.dataSources.remove(this.dataSource);
  }

  loadData(forceReload = false): void {
    if (!this.dataSource) {
      console.error('Viewer not initialized');
      return;
    }

    const bbox = toIGNBBoxString(getCameraBoundingBox(this.viewer));

    if (this.previouslyLoadedBbox === bbox && !forceReload) {
      return;
    }

    this.previouslyLoadedBbox = bbox;

    if (bbox) {
      this.isLoading = true;

      const url = `${this.url}${bbox}`;
      fetch(url)
        .then(res => res.json())
        .then((geojson: FeatureCollection) => {
          this.buildRoad(this.filterTypeRoad(geojson));
        }).catch(error => {
          console.error('[RoadLayer] -> (error) -> ', error);
          this.isLoading = false;
        });
    }
  }

  filterTypeRoad(res: FeatureCollection): FeatureCollection {
    const filteredFeatures = res.features.filter((feature) => {
      const type = feature.properties.type_de_route;
      return type === 'Départementale'
        || type === 'Route intercommunale'
        || type === 'Autoroute'
        || type === 'Nationale';
    });

    return {
      ...res,
      features: filteredFeatures
    };
  }

  buildRoad(res: FeatureCollection): void {
    this.dataSource.load(res, {
      clampToGround: true,
    }).then(() => {
      this.dataSource.entities.values.forEach(entity => {
        if (entity.polyline) {
          const styles = this.roadStyle(entity.properties.type_de_route.valueOf());

          if (styles === undefined) {
            return;
          }

          entity.polyline.material = styles.material;
          entity.polyline.width = styles.width;
        }
      });

      this.setActive(true);
      this.isLoading = false;
    });
  }

  roadStyle(type): any {
    switch (type) {
      case 'Départementale':
      case 'Route intercommunale' :
        return {
          material: new Cesium.PolylineOutlineMaterialProperty({
            color: Cesium.Color.fromCssColorString('#FFA500'),
            outlineColor: Cesium.Color.BLACK,
            outlineWidth: 1
          }),
          width: new Cesium.ConstantProperty(4)
        };
      case 'Nationale':
        return {
          material: new Cesium.PolylineOutlineMaterialProperty({
            color: Cesium.Color.fromCssColorString('#FFA500'),
            outlineColor: Cesium.Color.BLACK,
            outlineWidth: 1
          }),
          width: new Cesium.ConstantProperty(6)
        };
      case 'Autoroute':
        return {
          material: new Cesium.PolylineOutlineMaterialProperty({
            color: Cesium.Color.fromCssColorString('#FF0000'),
            outlineColor: Cesium.Color.BLACK,
            outlineWidth: 1
          }),
          width: new Cesium.ConstantProperty(7)
        };
    }

    return undefined;
  }

  setActive(active: boolean): void {
    this.active = active;
    this.dataSource.show = active;

    if (active) {
      this.loadData();
    }
  }
}
